import { Component, Input } from '@angular/core';
import { IAlert } from 'src/app/core/dto';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { CommonModule } from '@angular/common';
import { TimeAgoPipe } from 'src/app/main/shared/pipes/basic.pipe';

@Component({
  selector: 'app-alert-schedule-slip',
  templateUrl: './alert-schedule-slip.component.html',
  styleUrls: ['./alert-schedule-slip.component.scss'],
  imports: [CommonModule, FlexLayoutModule, MatTooltipModule, TimeAgoPipe],
})
export class AlertScheduleSlipComponent {
  @Input() alert: IAlert = {} as IAlert;
}
